import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { memo } from 'react';

import { TranslationBlock, useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

type Props = {
    className?: string;
    messageId: keyof TranslationBlock;
};

const ContextHeaderComponent = ({ className = '', messageId }: Props) => {
    const formatMessage = useAppFormatMessage();

    return (
        <div className={className}>
            {messageId && <BodySecondary className="leading-6 uppercase">{formatMessage([messageId])}</BodySecondary>}
        </div>
    );
};

export const ContextHeader = memo<Props>(ContextHeaderComponent);
